import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BrokerPortfolioTypesEnum, DashFeaturesEnum } from 'dash-common';
import {
  Button,
  ModalContext,
  TooltipWrapper,
  ViewerContext,
  useCheckIfSubscriptionFeatureActiveBroker,
} from 'dash-ui';
import { PortfolioListItemFragment } from 'gql/generated.graphql';
import { ButtonsContainer } from 'pages/portfolios/PortfoliosPage/components/PortfoliosPageView/components/PortfoliosListTableView/PortfoliosListTableView.styles';
import {
  getPreviewPortfolioLink,
  getPreviewPortfolioPropertyLink,
} from 'common/helpers/portfolio';
import { useNavigate } from 'react-router-dom';

const ActionCell = ({
  _id,
  portfolio,
}: {
  _id: string;
  portfolio: PortfolioListItemFragment;
}) => {
  const { t } = useTranslation(['pages', 'common']);
  const { toggleModal, setPayload } = useContext(ModalContext);
  const navigate = useNavigate();
  const { broker, profile } = useContext(ViewerContext);
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING,
  ]);

  return (
    <ButtonsContainer justifyContent="flex-end">
      <Button
        square
        medium
        icon="visibility"
        onClick={(e) => {
          e.stopPropagation();
          const isFolder = portfolio.type === BrokerPortfolioTypesEnum.FOLDER;
          if (isFolder) {
            return window?.open(
              getPreviewPortfolioLink(portfolio, broker, profile)
            );
          }
          window?.open(
            getPreviewPortfolioPropertyLink(portfolio, broker, profile),
            '_blank'
          );
        }}
      />
      <Button
        medium
        square
        icon="share"
        onClick={(e) => {
          e.stopPropagation();
          if (checkFeatureAccess()) {
            toggleModal(true, 'SharePortfolioModal');
            setPayload({ portfolio });
          }
        }}
        mx={2}
        iconProps={{ size: 20 }}
      />
      {portfolio.type === BrokerPortfolioTypesEnum.ITEM && (
        <TooltipWrapper
          content={t('pages:portfolioDetailsPage:labels:moveProperty')}
        >
          <Button
            medium
            square
            icon="driveFileMove"
            mr={2}
            iconProps={{ size: 20 }}
            data-tooltip-id={`${_id}-move-property`}
            onClick={() => {
              if (checkFeatureAccess()) {
                toggleModal(true, 'MovePropertyToFolderModal');
                setPayload({ portfolioIds: [portfolio._id] });
              }
            }}
          />
        </TooltipWrapper>
      )}
      <Button
        medium
        square
        icon="trash"
        colorVariation="danger"
        onClick={() => {
          if (!checkFeatureAccess()) {
            return;
          }
          if (portfolio.type !== BrokerPortfolioTypesEnum.ITEM) {
            toggleModal(true, 'RemovePropertyFromPortfolio');
            setPayload({
              folderId: '',
              // @ts-ignore
              propertyId: portfolio.property._id,
            });
          } else {
            toggleModal(true, 'RemoveFolderFromPortfolio');
            setPayload({
              folderId: portfolio._id,
              propertyId: '',
            });
          }
        }}
      />
    </ButtonsContainer>
  );
};

export default ActionCell;
